import { useEffect, useState } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { useDispatch, useSelector } from 'react-redux';
import { getPlaidToken, hideSuccessBankAddedPopup, submitPlaidToken } from '../../../actions';
import { CustomPortal } from '../../../commonComponents';
import { ShowAchAuthorizationPopup } from '../../../constants/ff.posthog';
import { resetInviteProfessionals } from '../../../domain/utils';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { OutlineLibraryIcon as LibraryIcon } from '@tempmee/react-icons';
import { AchAuthorizationPopup } from '../../AchAuthorizationPopup/AchAuthorizationPopup';
import { useModal } from '../../ModalQueue';
import { ModalOrder } from '../../ModalQueue/modalOrder';
import { PaymentCard } from './PaymentCard';

export const BankList = ({ selectedPayment, setSelectedPayment }) => {
  const dispatch = useDispatch();
  const allPayments = useSelector((state) => state.payments.allPayments);
  const showSuccessBankAddedPopup = useSelector(
    (state) => state.payments.showSuccessBankAddedPopup,
  );
  const plaidToken = useSelector((state) => state.payments.plaidToken);
  const [showAchPopup, setShowAchPopup] = useState(false);
  const [pendingPlaidData, setPendingPlaidData] = useState(null);

  const isAchPopupEnabled = useFeatureFlag(ShowAchAuthorizationPopup);

  const { isActive: isSuccessPopupActive } = useModal({
    id: ModalOrder.BANK_SUCCESS_POPUP,
    condition: showSuccessBankAddedPopup,
  });

  const submitPlaidData = (publicToken, metadata, achMandateAuthorized = false) => {
    dispatch(submitPlaidToken({ metadata, publicToken, ...(achMandateAuthorized && { achMandateAuthorized }) }));
    resetInviteProfessionals();
  };

  const { open } = usePlaidLink({
    token: plaidToken,
    onSuccess: (publicToken, metadata) => {
      if (isAchPopupEnabled) {
        setPendingPlaidData({ publicToken, metadata });
        setShowAchPopup(true);
      } else {
        submitPlaidData(publicToken, metadata);
      }
    },
  });

  const handleAchConfirm = () => {
    setShowAchPopup(false);
    if (pendingPlaidData) {
      submitPlaidData(pendingPlaidData.publicToken, pendingPlaidData.metadata, true);
      setPendingPlaidData(null);
    }
  };

  const bankList = allPayments
    ?.filter((item) => item.type === 'bank_account')
    .sort((a, b) => (b.is_selected === true) - (a.is_selected === true));

  useEffect(() => {
    dispatch(getPlaidToken());
  }, [dispatch]);

  return (
    <>
      <PaymentCard
        dataCy="bank-list-payment"
        data={bankList}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
        IconComponent={LibraryIcon}
        title="Bank Account"
        description="(Adding a Bank Account is the preferred method as you avoid the 3.5% Convenience Fee)."
        addPaymentText="Add Bank Account"
        handleAddPaymentButton={open}
      />

      {showAchPopup && <AchAuthorizationPopup onConfirm={handleAchConfirm} />}

      {isSuccessPopupActive && (
        <CustomPortal
          dataCy="bank-list-payment-success-popup"
          isSuccess
          redirect={false}
          title="Bank Account Successfully Added!"
          text="Your bank account information has been successfully added to your account."
          submitPressed={() => {
            dispatch(hideSuccessBankAddedPopup());
          }}
          rightButtonDataCy="btn-ok"
        />
      )}
    </>
  );
};
